import './styles/base.css';

import { mountCreateView } from './create/main';
import { mountInfoView } from './info/main';
import { mountIndexView } from './index/main';
import { mountJurorView } from './juror/main';
import { mountMarketView } from './market/main';

const app = document.querySelector('#app') as HTMLElement | null;
if (!app) {
  throw new Error('Missing #app root element');
}

const params = new URLSearchParams(window.location.search);
const market = params.get('market');
const info = params.get('info');
const juror = params.get('juror');
const create = params.get('create');
const normalizedPath = window.location.pathname.replace(/\/+$/, '');
const isCreatePath = normalizedPath.endsWith('/create');

if (create && !isCreatePath) {
  window.history.replaceState(null, '', `${import.meta.env.BASE_URL}create/`);
}

if (info) {
  mountInfoView(app, info as `0x${string}`).catch((error: Error) => {
    const container = document.createElement('div');
    container.className = 'app';
    const card = document.createElement('div');
    card.className = 'card';
    card.style.padding = '16px';
    card.style.marginTop = '20px';
    card.textContent = error?.message || 'Failed to load market analytics view.';
    container.appendChild(card);
    app.innerHTML = '';
    app.appendChild(container);
  });
} else if (market) {
  mountMarketView(app, market as `0x${string}`).catch((error: Error) => {
    const container = document.createElement('div');
    container.className = 'app';
    const card = document.createElement('div');
    card.className = 'card';
    card.style.padding = '16px';
    card.style.marginTop = '20px';
    card.textContent = error?.message || 'Failed to load market view.';
    container.appendChild(card);
    app.innerHTML = '';
    app.appendChild(container);
  });
} else if (juror) {
  mountJurorView(app);
} else if (create || isCreatePath) {
  mountCreateView(app);
} else {
  mountIndexView(app);
}
